import React from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import HeaderTwo from "../../components/HeaderTwo";
import Breadcrumb from "../../components/Breadcrumb";
import FooterTwo from "../../components/FooterTwo";
import BottomFooter from "../../components/BottomFooter";
import ShippingOne from "../../components/ShippingOne";
import Contact from "../../components/Contact";
import ScrollToTop from "react-scroll-to-top";
import Layout from "../../components/user/Layout";
const ContactPage = () => {
  return (
    <>
      <Layout>
        {/* ColorInit */}
        <ColorInit color={true} />

        {/* ScrollToTop */}
        <ScrollToTop smooth color="#FA6400" />

        {/* Preloader */}
        <Preloader />

        {/* HeaderTwo */}
        {/* <HeaderTwo category={true} /> */}

        {/* <Breadcrumb title={"Contact"} /> */}

        {/* Contact */}
        <Contact />

        {/* ShippingOne */}
        <ShippingOne />

        {/* FooterTwo */}
        {/* <FooterTwo /> */}

        {/* BottomFooter */}
        {/* <BottomFooter /> */}
      </Layout>
    </>
  );
};

export default ContactPage;
